import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-not-present',
	templateUrl: './icon-not-present.component.svg',
})
export class IconNotPresentComponent {}
